import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { IconOrbit } from "./IconOrbit";
import { scrollToId } from "../lib/scroll";

const headlineLines = ["Small studio.", "Real products."];

const goTo = (href) => scrollToId(href);

export const Hero = () => {
  const reduce = useReducedMotion();

  return (
    <section
      data-testid="hero"
      className="ambient relative overflow-hidden bg-surface pt-24 md:pt-32"
      style={{ backgroundColor: "#FFFFFF" }}
    >
      <div className="mx-auto max-w-6xl px-6 lg:px-8">
        <div className="grid items-center gap-14 lg:grid-cols-[1.05fr_0.95fr] lg:gap-8">
          {/* Copy */}
          <div className="max-w-xl">
            <motion.div
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.05 }}
            >
              <span className="font-mono text-[11px] uppercase tracking-eyebrow text-platinum">
                MisiDigi Studio
              </span>
            </motion.div>

            <h1 className="mt-5 font-extrabold leading-[1.02] tracking-tight text-ink text-[clamp(2.7rem,7.5vw,4rem)]">
              {headlineLines.map((line, i) => (
                <span key={line} className="line-mask">
                  <motion.span
                    className="block"
                    initial={reduce ? { opacity: 0 } : { y: "110%" }}
                    animate={reduce ? { opacity: 1 } : { y: "0%" }}
                    transition={{
                      duration: 0.8,
                      delay: 0.15 + i * 0.12,
                      ease: [0.22, 1, 0.36, 1],
                    }}
                  >
                    {line}
                  </motion.span>
                </span>
              ))}
            </h1>

            <motion.p
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              className="mt-6 max-w-md text-[16px] leading-relaxed text-slatetx text-balance"
            >
              We build useful digital products with thoughtful design,
              commercial thinking, and modern technology.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.7 }}
              className="mt-8 flex items-center gap-6"
            >
              <button
                data-testid="hero-explore-cta"
                onClick={() => goTo("#products")}
                className="group inline-flex items-center gap-2 rounded-full bg-ink px-6 py-3.5 text-[14px] font-semibold text-white transition-all hover:bg-steel"
              >
                Explore Products
                <ArrowRight
                  size={16}
                  className="transition-transform group-hover:translate-x-0.5"
                />
              </button>
              <button
                data-testid="hero-howwebuild-link"
                onClick={() => goTo("#how-we-build")}
                className="text-[14px] font-medium text-slatetx underline-offset-4 transition-colors hover:text-ink hover:underline"
              >
                How We Build
              </button>
            </motion.div>
          </div>

          {/* Interactive product icon orbit */}
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="relative mx-auto h-[350px] w-full max-w-[540px] sm:h-[430px]"
          >
            <IconOrbit />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
